import React, { Component } from 'react';
import { Input } from 'antd';
import { GraphWrapper } from '@/components/Graph';
import { overallEffectLine } from '@/components/DataEffect/GraphConfig';
import introImg from '@/assets/intro_2x.png';
import Lightbox from 'react-image-lightbox';
import { bodyScroll } from '@/shared/utils';
import './index.less';
import DownloadDialog from "@/components/DataEffect/Download";
const { Search } = Input;
export default class EffectInticator extends Component {
    constructor(props) {
        super(props);
        this.columns = [{
                title: '日期',
                key: 'date',
                dataIndex: 'date',
            }, {
                title: '会员',
                key: 'phone',
                dataIndex: 'phone',
            }, {
                title: '精准度',
                key: 'precision',
                dataIndex: 'precision',
            }, {
                title: '召回率',
                key: 'back',
                dataIndex: 'back',
            }, {
                title: '覆盖率',
                key: 'cover',
                dataIndex: 'cover',
            }, {
                title: '多样性',
                key: 'diversity',
                dataIndex: 'diversity',
            }];
        this.closeSwiper = () => {
            this.setState({
                showBigImg: false,
            });
            bodyScroll.can();
        };
        this.openSwiper = () => {
            this.setState({
                showBigImg: true,
            });
            bodyScroll.forbidden();
        };
        this.state = {
            // pageNo: 1,
            // pageSize: 10,
            // total: 30,
            // vipList: [],
            showBigImg: false,
            currentComparisonGroup: [],
        };
    }
    componentDidMount() {
        const { recommendIndexs } = this.props.dataEffectValue;
        const { overallEffect } = recommendIndexs;
        this.setState({
            currentComparisonGroup: overallEffect || {},
        });
    }
    handlePageSizeChange(current, size) {
        this.setState({
            pageSize: size,
        });
    }
    handlePageNoChange(page) {
        this.setState({
            pageNo: page,
        });
    }
    render() {
        // const { currentComparisonGroup, vipList, pageNo, pageSize, total } = this.state;
        const { currentComparisonGroup, showBigImg, } = this.state;
        const { sceneCode } = this.props.dataEffectValue;
        return (<div className="effect-indicator">
        <div className="data-effect-title mb_20">整体情况</div>
        <div className="border">
          <p>推荐结果评价指标</p>
          <GraphWrapper className="overall-effect-graph-wrapper" config={overallEffectLine(currentComparisonGroup, currentComparisonGroup.isRate)} height={350}/>
          <DownloadDialog key={2} className="traffic-bucket-content-graphs-btn" type="recomQuota" sceneCode={sceneCode}/>
          <div className="effect-indicator-imgbox">
            <hr className="line1"/>
            <hr className="line2"/>
            <hr className="line3"/>
            <img src={introImg} alt="" onClick={this.openSwiper}/>
          </div>
        </div>
        {showBigImg && (<div className="picture-gallery-swiper-wrapper">
            <Lightbox wrapperClassName="picture-gallery-lightbox" clickOutsideToClose={false} mainSrc={introImg} nextSrc={introImg} prevSrc={introImg} onCloseRequest={this.closeSwiper}/>
          </div>)}
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
      </div>);
    }
}
